import { render, staticRenderFns } from "./config-builder.vue?vue&type=template&id=f1d9fa8c&scoped=true&"
import script from "./config-builder.vue?vue&type=script&lang=js&"
export * from "./config-builder.vue?vue&type=script&lang=js&"
import style0 from "./config-builder.vue?vue&type=style&index=0&id=f1d9fa8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d9fa8c",
  null
  
)

export default component.exports